import { Component } from "@angular/core";
import { ActivatedRoute,Router } from "@angular/router";
import { ToastService } from "angular-toastify";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { SupplierContact } from "@interfaces/supplierContact.interface";
import { SupplierDocument } from "@interfaces/supplierDocument.interface";
import { StockStoreService } from "@services/stockStore.service";
import { StockStore } from "@interfaces/stockStore.interface";
import { StockStoreHistoryService } from "@services/stockStoreHistory.service";
import { StockStoreHistory } from "@interfaces/stockStoreHistory.interface";

@Component({
	moduleId: module.id,
	selector: "stores-id",
	styleUrls: ["stores-id.css"],
	templateUrl: "stores-id.html"
})
export class StoresIdAdminComponent {
	checkInOutDropdown: any = [{ id: true, name: "Check In" }, { id: false, name: "Check Out" }]
	contacts: SupplierContact[] = [];
	createEnabled = true;
	documents: SupplierDocument[] = [];
	editEnabled = true;
	headerPrimaryButtons: AdminHeaderButton[] = [];
	headerTertiaryButtons: AdminHeaderButton[] = [];
	history: StockStoreHistory[] = [];
	item: StockStore = new StockStore();
	itemId = 0;
	itemType = "Store Item";
	popupAddButtonOptions: any;
	popupCheckInOut: any = { checkIn: true, quantity: 1 };
	popupCloseButtonOptions: any = { onClick: () => this.closePopup(), text: "Close" };
	popupTitle = "";
	popupVisible = false;
	readOnly = true;
	returnUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	title: string = "View " + this.itemType;

	constructor(private router: Router, private toastService: ToastService, private route: ActivatedRoute, private itemService: StockStoreService, private historyService: StockStoreHistoryService) {
		this.buildButtons("view");

		this.route.params.subscribe((params) => {
			if (params.id != "create") {
				if (params.id.split("_").length > 1) {
					this.itemId = params.id.split("_")[0];
					this.getItem(this.itemId);
					this.edit();
				} else {
					this.itemId = params.id;
					this.getItem(params.id);
				}
			} else {
				this.create();
			}
		});
	}

	boolYesNo(cellInfo: any){
		if(cellInfo.value === true)
		{
			return "YES";
		}
		else
		{
			return "NO";
		}
	}

	buildButtons(mode: string) {
		if (mode == "edit" && this.editEnabled) {
			this.headerPrimaryButtons = [
				{ method: "updateItem", text: "Save Changes" },
				{ method: "cancelEditing", text: "View Mode" },
				{ method: "close", text: "Close" }
			];
			this.headerTertiaryButtons = [
				{ method: "viewPurchaseLog", text: "View Purchase Log" },
				{ method: "viewSupplier", text: "View Document" }
			];
		} else if (mode == "view") {
			this.headerPrimaryButtons = [
				{ method: "edit", text: "Edit" },
				{ method: "close", text: "Close" }
			];
			this.headerTertiaryButtons = [
				{ method: "checkInOutPopup", text: "Check In / Out" },
				{ method: "viewPurchaseLog", text: "View Purchase Log" },
				{ method: "viewSupplier", text: "View Supplier" }
			];
		}
	}

	cancelEditing() {
		this.readOnly = true;
		this.buildButtons("view");
		this.title = "View " + this.itemType;
	}

	checkInOut() {
		if (this.popupCheckInOut.quantity <= 0) {
			alert("Quantity must be at least 1");
			return;
		}
		if (this.popupCheckInOut.checkIn === true) {
			this.itemService.checkIn(this.item.id, this.popupCheckInOut.quantity)
				.subscribe(
					() => {
						this.getItem(this.itemId);
					},
					(err) => {
						console.log(err);
						this.toastService.error("Something Went Wrong!");
					}
				);
		} else {
			this.itemService.checkOut(this.item.id, this.popupCheckInOut.quantity)
				.subscribe(
					() => {
						this.getItem(this.itemId);
					},
					(err) => {
						console.log(err);
						this.toastService.error("Something Went Wrong!");
					}
				);
		}
		this.closePopup();
	}

	checkInOutPopup() {
		this.popupTitle = "Check In / Out";
		this.popupCheckInOut = { checkIn: true, currentStock: this.item.quantity, quantity: 1 };
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.checkInOut(), text: "Check In / Out" };

		return false;
	}

	close() {
		this.router.navigate([`/${this.returnUrl}/`]);
	}
	
	closePopup() {
		this.popupVisible = false;
	}

	create() {
		this.readOnly = false;
		this.buildButtons("create");
		this.title = "Create New " + this.itemType;
	}

	createItem() {
		this.itemService.createSingle(this.item)
			.subscribe(
				() => {
					this.toastService.success("Successfully Updated " + this.itemType);
					this.item = new StockStore();
					this.close();
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	edit() {
		this.readOnly = false;
		this.buildButtons("edit");
		this.title = "Edit " + this.itemType;
		this.toastService.warn("You are now editing...");
	}

	getHistory(itemId: number){
		this.historyService.getByItemId(itemId)
			.subscribe(
				(res: any) => {
					this.history = res.response;
				},
				(err) => {console.log(err); this.toastService.error("Something Went Wrong!");}
			);
	}

	getItem(itemId: number) {
		this.itemService.getDetails(itemId)
			.subscribe(
				(res: any) => {
					this.item = res.response;
					this.getHistory(res.response.id);
				},
				(err) => {console.log(err); this.toastService.error("Something Went Wrong!");}
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	isTogglePurchaseTypeOffVisible(e: any) {
		return e.row.data.isSelected === true;
	}

	isTogglePurchaseTypeOnVisible(e: any) {
		return e.row.data.isSelected === false;
	}

	updateItem() {
		this.itemService.updateSingleById(this.item.id, this.item)
			.subscribe(
				() => this.toastService.success("Successfully Updated "),
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	viewPurchaseLog(){
		this.router.navigate([`admin//purchaseLogs/${this.item.purchaseLog.lookupId}`]);
	}

	viewSupplier(){
		this.router.navigate([`admin/suppliers/${this.item.purchaseLog.supplierId}`]);
	}
}